export const createFullscreenIcon = () => {
  const fullscreenIcon = document.createElement('div');

  fullscreenIcon.className = 'cloudimage-360-fullscreen-icon';

  return fullscreenIcon;
};
